//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'candy-wrap',
    colors: ['#f19797', '#f9b73e', '#ee5151', '#fb671f', '#6bbe3a', '#0c75b7', '#0b9e4e', '#763f68'],
    stroke: '#302319',
    background: '#e7ded5',
    type: 'orbifold',
  },
  {
    name: 'slicks',
    colors: ['#e1decd', '#d95336', '#e6ac1d'],
    stroke: '#302319',
    background: '#e1decd',
    type: 'orbifold',
  },
  {
    name: 'circus',
    colors: ['#3eb79e', '#f4a910', '#f37377', '#207986', '#f26003', '#afce95'],
    stroke: '#302319',
    background: '#eadcb6',
    type: 'orbifold',
  },
  {
    name: 'spotlight',
    colors: ['#f34312', '#00a49e', '#ef888f', '#f5b408', '#412432'],
    stroke: '#412432',
    background: '#dfdcd5',
    type: 'orbifold',
  },
  {
    name: 'five-stars',
    colors: ['#f5e8c7', '#d9dcad', '#cf3933', '#f3f4f4', '#74330d', '#8bb896', '#eba824', '#f05c03'],
    stroke: '#380c05',
    background: '#ecd598',
    type: 'orbifold',
  },
  {
    name: 'full-moon',
    colors: ['#f7e8be', '#aa879f', '#f6634e'],
    stroke: '#2a1f39',
    background: '#f7e8be',
    type: 'orbifold',
  },
  {
    name: 'sunday-stroll',
    colors: [
      '#d44c4c',
      '#e47781',
      '#f5d274',
      '#f7e8be',
      '#acbe55',
      '#6fb97a',
      '#5ba150',
      '#037750',
      '#003e5e',
      '#595373',
      '#73659e',
      '#ac879f',
    ],
    background: '#e5cbb5',
    w: 2,
    type: 'orbifold',
  },
  {
    name: 'vegetable-soup',
    colors: ['#ec6a22', '#f7e9c5', '#399a3f', '#9ac764', '#fff7e0', '#ffcd6b', '#634754', '#98c195', '#708658'],
    background: '#fff7e0',
    w: 2,
    type: 'orbifold',
  },
  {
    name: 'risograph',
    colors: ['#f56f64', '#f9cb1f', '#f0eace'],
    stroke: '#295042',
    background: '#f0eace',
    w: 1,
    type: 'orbifold',
  },
  {
    name: 'tote-bag',
    colors: ['#f5f5f5', '#ffc6cf', '#fd5105', '#4124b0'],
    stroke: '#231e22',
    background: '#ffc6cf',
    w: 1,
    type: 'orbifold',
  },
  {
    name: 'slicks',
    colors: ['#ffbdd0', '#ff4328', '#e88526', '#21b929', '#2193c9', '#fffcea', '#ffcc21'],
    stroke: '#fffcea',
    background: '#212121',
    w: 1,
    type: 'orbifold',
  },
];
